import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { CONSTANT, ModalService, AnalyticsService, AdobeService, ADOBE_TAGS } from '@sm360/widget-commons-general';

import { FORGET_PASSWORD, LOGIN } from 'login/constants/modalNames.js';
import TAGS from 'login/constants/trackingTags';
import PropTypes from 'prop-types';

import 'login/components/SignIn/Links/ForgetPasswordLink.scss';

class ForgetPasswordLink extends React.Component {
    constructor(props) {
        super(props);

        this.onPasswordForgotten = this.onPasswordForgotten.bind(this);
    }

    onPasswordForgotten(e) {
        e.preventDefault();
        ModalService.get(FORGET_PASSWORD).open();
        ModalService.get(LOGIN).close();
        AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__FORGOT_PASSWORD());
        if (this.props.hasAdobeTagging) {
            AdobeService.eventTrigger(ADOBE_TAGS.LOGIN_CTA(CONSTANT.ACCOUNT.FORGOT), 'global-onclick');
        }
    }

    render() {
        return (
            <div className="forgotPassword">
                <button
                    onClick={this.onPasswordForgotten}
                    className="sr-link"
                    data-test="login.sign-in.forget-password-redirection-button"
                >
                    {LocaleService.t('LOGIN.FORGOT_PASSWORD')}
                </button>
            </div>
        );
    }
}

ForgetPasswordLink.propTypes = {
    hasAdobeTagging: PropTypes.bool,
};

ForgetPasswordLink.defaultProps = {
    hasAdobeTagging: false,
};

ForgetPasswordLink.displayName = 'ForgetPasswordLink';

export default ForgetPasswordLink;
